import { memo } from 'react';
import { KanbanListRole, LIST_ROLE_CONFIG } from '../../types/kanban';
import { cn } from '../../utils/cn';

interface KanbanListRoleBadgeProps {
  role: KanbanListRole;
  className?: string;
}

export const KanbanListRoleBadge = memo(({ role, className }: KanbanListRoleBadgeProps) => {
  if (role === 'none') return null;
  const config = LIST_ROLE_CONFIG[role];
  return (
    <span
      className={cn('badge border', className)}
      style={{
        backgroundColor: `${config.color}15`,
        borderColor: `${config.color}30`,
        color: config.color,
      }}
    >
      {config.label}
    </span>
  );
});
KanbanListRoleBadge.displayName = 'KanbanListRoleBadge';
